+function ($) {
  $("#open-menu-responsive").on('click', function() {
      $('.dialog-off-canvas-main-canvas').addClass("mask-effect-body");
  });

  $("#close-menu-responsive").on('click', function() {
    $('.dialog-off-canvas-main-canvas').removeClass("mask-effect-body");
  });

  $(window).on('resize', function() {
    if($('.dialog-off-canvas-main-canvas.mask-effect-body').length) {
      $('.dialog-off-canvas-main-canvas').removeClass("mask-effect-body");
    }
  });

  // responive table
  $(function() {
    $(".table-wrap").each(function() {
      var nmtTable = $(this);
      var nmtHeadRow = nmtTable.find("thead tr");
      nmtTable.find("tbody tr").each(function() {
        var curRow = $(this);
        for (var i = 0; i < curRow.find("td").length; i++) {
          var rowSelector = "td:eq(" + i + ")";
          var headSelector = "th:eq(" + i + ")";
          curRow.find(rowSelector).attr('data-title', nmtHeadRow.find(headSelector).text());
        }
      });
    });
  });

  // scroll to top
  function scroll_to_top(oElm) {
    $(oElm).on('click', function() {
      $('html,body').animate({scrollTop: 0}, 'slow');
    });
  }
  scroll_to_top("a.go-to-top");

}(jQuery);
